import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';  
import { faGithub, faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'; 

const Footer = () => {
  return (
    <footer className='footer text-center mt-4'>
        
        <div className="social-icons">

            <a href="https://github.com/rjohn151"
                className='icons github me-2'
                target="_blank" rel="noreferrer noopener"
            >
            <FontAwesomeIcon size='2x' icon={faGithub}/>
            </a>
            <a href="https://facebook.com"
                className='icons facebook me-2'
                target="_blank" rel="noreferrer noopener"
            >
            <FontAwesomeIcon size='2x' icon={faFacebook}/>
            </a>
            <a href="https://www.instagram.com/ramoneeej/"
                className='icons instagram me-2'
                target="_blank" rel="noreferrer noopener"    
            >
            <FontAwesomeIcon size='2x' icon={faInstagram}/>
            </a>
            <a href="https://linkedin.com/in/ramone-johnson"
                className='icons linkedin me-2'
                target="_blank" rel="noreferrer noopener"
            >
            <FontAwesomeIcon size='2x' className='' icon={faLinkedin}/>
            </a>
        </div>
    
        <p className='mb-0'>Designed & Built by Ramone Johnson</p>
        {/* <p>Copyright &copy; 2022 All Rights Reserved</p> */}
  
    </footer>
  )
}

export default Footer